(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-clothing-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cloq-hero]').forEach((hero)=>{
  const video=hero.querySelector('video');
  const toggle=hero.querySelector('[data-cloq-hero-toggle]');
  if(!video||!toggle||toggle.dataset.bound==='true')return;
  toggle.dataset.bound='true';
  const update=()=>{
    toggle.setAttribute('aria-label',video.paused?'Play video':'Pause video');
    const label=toggle.querySelector('span');
    if(label)label.textContent=video.paused?'▶':'Ⅱ';
  };
  video.muted=true;
  video.defaultMuted=true;
  video.loop=true;
  video.playsInline=true;
  const play=()=>{
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    video.play().catch(()=>{});
  };
  toggle.addEventListener('click',()=>{
    if(video.paused)play();else video.pause();
    update();
  });
  video.addEventListener('playing',update);
  video.addEventListener('pause',update);
  video.addEventListener('error',update);
  play();
  update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cloq-related-products"] && !Shopify.designMode) return;
  try {
    
function cloqLoadRecommendations(scope=document){
  scope.querySelectorAll('[data-cloq-recommendations]:not([data-loading])').forEach(root=>{
    root.dataset.loading='true';
    const load=()=>fetch(root.dataset.url).then(response=>{if(!response.ok)throw new Error(String(response.status));return response.text();}).then(html=>{
      if(!root.isConnected)return;
      const result=new DOMParser().parseFromString(html,'text/html').querySelector('[data-cloq-recommendations]');
      if(result)root.innerHTML=result.innerHTML;
    }).catch(()=>{root.hidden=true;});
    if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){observer.disconnect();load();}},{rootMargin:'300px'});observer.observe(root);}else load();
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>cloqLoadRecommendations(),{once:true});else cloqLoadRecommendations();
document.addEventListener('shopify:section:load',event=>cloqLoadRecommendations(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cncare-clothing-header"]) return;
  try {
    
async function cloqRefreshBag(announce=false){
  const bags=document.querySelectorAll('[data-cloq-bag]');
  if(!bags.length)return;
  try{
    const response=await fetch(bags[0].dataset.cartUrl,{headers:{Accept:'application/json'}});
    if(!response.ok)return;
    const cart=await response.json();
    bags.forEach(bag=>{bag.setAttribute('aria-label',bag.dataset.label+' ('+cart.item_count+')');const count=bag.querySelector('.cc-bag-count');if(count)count.textContent=cart.item_count;});
    const notice=document.querySelector('.cloq-cart-status');
    if(notice&&announce&&cart.item_count>0)notice.hidden=false;
  }catch(error){console.warn('CLOQ bag count could not refresh:',error.name);}
}
import('https://cdn.shopify.com/storefront/standard-events.js').then(({StandardEvents})=>{
  document.addEventListener(StandardEvents.cartLinesUpdate,event=>{
    if(event.promise)event.promise.then(result=>{if(!result?.detail?.didError)cloqRefreshBag(event.action==='add');}).catch(()=>{});
  });
}).catch(error=>console.warn('CLOQ bag updates unavailable:',error.name));
window.addEventListener('pageshow',event=>{if(event.persisted)cloqRefreshBag();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
